import { render, staticRenderFns } from "./RoleJurisdiction.vue?vue&type=template&id=050fa054&scoped=true&"
import script from "./RoleJurisdiction.vue?vue&type=script&lang=js&"
export * from "./RoleJurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./RoleJurisdiction.vue?vue&type=style&index=0&id=050fa054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050fa054",
  null
  
)

export default component.exports